/**
 * Trackonomics
 * @category Functional Component
 * @summary Includes the Trackonomics JS lib.
 * @return {Node} React node containing the trackonomics JS lib.
 */
const Trackonomics = props => {
  return (
    <script
      id='funnel-relay-installer'
      data-property-id='PROPERTY_ID'
      data-customer-id='cbsint_a10ef_thedrewbarrymoreshow'
      src='https://cdn-magiclinks.trackonomics.net/client/static/v2/cbsint_a10ef_thedrewbarrymoreshow.js'
      async='async'
      type='text/plain'
      className='optanon-category-2'
    />
  );
}

export default Trackonomics;
